module.exports = "/_next/static/images/UDJ3-0efafd634aaa475b0113ea956d990ae7.svg";